module.exports = __webpack_public_path__ + "static/media/T.3d56d561.jpg";